export default (env = process.env) => ({
  stripeKey: "pk_test_d9MMtpuxpTehJzQLnFF2PHqj",
});
